/* eslint-disable @typescript-eslint/ban-types */

import { CountryCode, isValidPhoneNumber } from "libphonenumber-js";
import * as yup from "yup";

import { isBlank } from "@/utils/any";

/** If `T` is optional, returns optional `U`. */
type MaintainOptionality<T, U> = T extends undefined ? U | undefined : U;

/**
 * TODO: Remove. Old name. Use `phone`.
 */
yup.addMethod<ReturnType<typeof yup.string>>(
  yup.string,
  "phoneNumber",
  function (defaultCountryCode?: CountryCode) {
    return this.test(
      "phoneNumber",
      "${label} is not a valid phone number",
      (value) => {
        if (value == null) return true;
        return isValidPhoneNumber(value, defaultCountryCode);
      }
    );
  }
);

yup.addMethod<ReturnType<typeof yup.string>>(yup.string, "phone", function (
  defaultCountryCode?: CountryCode
) {
  return this.test("phone", "${label} is not a valid phone number", (value) => {
    if (value == null) return true;
    return isValidPhoneNumber(value, defaultCountryCode);
  });
});

/**
 * TODO: Remove. Old name. Use `presence`.
 */
yup.addMethod<ReturnType<typeof yup.string>>(
  yup.string,
  "emptyToNull",
  function () {
    return this.transform(function (value) {
      if (value === "") return null;
      return value;
    });
  }
);

yup.addMethod<ReturnType<typeof yup.mixed>>(yup.mixed, "presence", function () {
  return this.transform(function (value) {
    if (isBlank(value)) return undefined;
    return value;
  });
});

yup.addMethod<ReturnType<typeof yup.string>>(yup.string, "enum", function (
  enumeration
) {
  return this.oneOf(Object.values(enumeration));
});

declare module "yup" {
  interface Schema<T, C = object> {
    /**
     * Converts blank values to `undefined`. Blank values are determined by
     * `isBlank` function in utils/functions.
     */
    presence(): this;
  }

  interface StringSchema<
    T extends string | null | undefined = string | undefined,
    // eslint-disable-next-line @typescript-eslint/ban-types
    C = object
  > {
    /**
     * @deprecated
     *
     * Validates a string is a valid E.164 phone number.
     */
    phoneNumber(defaultCountryCode?: CountryCode): this;

    /**
     * Validates a string is a valid E.164 phone number.
     */
    phone(defaultCountryCode?: CountryCode): this;

    /**
     * @deprecated
     *
     * Converts empty strings `""` to `null`.
     */
    emptyToNull(): this;

    /**
     * Validates string is one of enum values.
     */
    enum<U extends T>(options: {
      [s: string]: U;
    }): StringSchema<MaintainOptionality<T, U>, C>;
  }
}
